import { useTranslation } from 'react-i18next'

export const ActivateAnnouncementNumberCard = () => {
  const { t } = useTranslation(['rewards-gift'])
  return (
    <div className="activate-announcement-number-card">
      <h2 className="activate-announcement-number-card__title">
        {t('rewards-gift:activateAnnouncementNumberCard.title')}
        <img
          src="/images/Star3D.svg"
          alt={t('rewards-gift:activateAnnouncementNumberCard.starIconAlt')}
        />
      </h2>
      <p className="activate-announcement-number-card__message">
        {t('rewards-gift:activateAnnouncementNumberCard.message')}
      </p>
    </div>
  )
}
